import { ApiGeoUnitWithDayConstraints, ApiItem, ApiListOptions } from '@ibe/api';
import AnalyticsBase from './AnalyticsBase';

export type SearchParams = {
  endDate?: string;

  startDate?: string;

  pickupStation?: string;

  dropOffStation?: string;

  pickupStationGeoUnit?: ApiGeoUnitWithDayConstraints;

  pickupStationParentGeoUnit?: ApiGeoUnitWithDayConstraints;

  dropOffStationGeoUnit?: ApiGeoUnitWithDayConstraints;

  dropOffStationParentGeoUnit?: ApiGeoUnitWithDayConstraints;
};

class SearchDetailEvent extends AnalyticsBase {
  searchParams: SearchParams;

  listOptions: ApiListOptions;

  item?: ApiItem;

  nrResultsAvailable?: number;

  nrResultsOnRequest?: number;

  nrResults?: number;
}

export default SearchDetailEvent;
